module.exports = __webpack_public_path__ + "img/HomeESG2.6393419.png";